export const PAGE_TITLE: Record<string, string> = {
  "/": "All events",
  "/wa": "Overview",
  "/people": "People & replies",
  "/send": "Send",
  "/history": "Send history",
  "/settings": "Settings",
};
